export const EXAMPLE_PHOTO = "assets/images/example_watermark.png";
